<template>
  <div class="routerDiv" v-if="without_head">
    <div class="routerCont kycwidth">
      <span v-for='(item,index) in GlobalBreadArr' v-bind:key=index>
        <a v-if="index == GlobalBreadArr.length-1" class="active">{{getCurrName(item.name)}}</a>
        <a v-else :href="item.path">{{getCurrName(item.name)}}</a>
        <span class="slash">/</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      GlobalBreadArr: [],
      currPageName: '', // 当前页面的面包屑名
      without_head: true // 是否去掉头部
    }
  },
  methods: {
    // 生成面包屑数组
    createBreadInfo () {
      var _this = this
      // session用途：为了防止刷新时数据丢失,保存面包屑数组
      var sessionJson = sessionStorage.getItem('sessionBreadArr')
      if (sessionJson && sessionJson !== 'undefined') {
        _this.GlobalBreadArr = JSON.parse(sessionJson)
      }
      var name = _this.$route.meta.breadCrumbsName // 当前页面对应面包屑名称
      _this.currPageName = name
      var path = location.href // 当前页面地址

      // 1. 如果是三个模糊查询页面/高级筛查，直接将面包屑重置为首页
      var isSpecialbread = _this.$route.meta && _this.$route.meta.isSpecialbread
      if (isSpecialbread) {
        var obj1 = {
          name: 'Home',
          path: '/'
        }
        _this.GlobalBreadArr.splice(0, _this.GlobalBreadArr.length, obj1)
      }

      // 2. 当前页面已在面包屑中，更新地址并截取之前面包屑
      var flag = false // 当前页是否已在面包屑导航中
      for (var i = 0; i < _this.GlobalBreadArr.length; i++) {
        var item = _this.GlobalBreadArr[i]
        if (item.name === name) {
          flag = true
          item.path = path
          _this.GlobalBreadArr = _this.GlobalBreadArr.slice(0, i + 1)
          break
        }
      }

      // 3. 当前页面不在面包屑中，直接添加
      if (!flag) {
        var obj = {
          name: name,
          path: path
        }
        _this.GlobalBreadArr.push(obj)
      }
      sessionStorage.setItem('sessionBreadArr', JSON.stringify(_this.GlobalBreadArr))
    },

    // 获取当前name对应的显示内容
    getCurrName (name) {
      if (name === 'StockDetail' || name === 'AbroadStockDetail') {
        return decodeURI(decodeURI(sessionStorage.getItem('nav_company')))
      } else if (name === 'WCBasicInfo') {
        return decodeURI(decodeURI(sessionStorage.getItem('wc_name')))
      } else {
        return this.$t(name)
      }
    }
  },
  created () {
    var without_head = sessionStorage.getItem('without_head')
    if (without_head && Number(without_head) === 1) {
      this.without_head = false
      return
    }
    if (this.$route.meta && this.$route.meta.breadCrumbsName) {
      this.createBreadInfo()
    }
  },
  watch: {
    '$route': function (to) {
      if (this.$route.meta && this.$route.meta.breadCrumbsName) {
        this.createBreadInfo()
      }
    }
  }
}
</script>
<style>
.routerDiv {
  background-color: #FFFFFF;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  line-height: 26px;
}

.routerDiv .routerCont {
  margin: 0 auto 15px auto;
  padding: 8px 0 8px 10px;
  border: 1px solid #eaeef1;
}

.routerDiv .routerCont a,
.routerDiv .routerCont a:hover {
  color: #405EC7;
  text-decoration: none;
  cursor: pointer;
}

.routerDiv .routerCont a.active,
.routerDiv .routerCont a.active:hover {
  color: #666666;
  cursor: default;
}

.routerDiv .routerCont span.slash {
  display: inline-block;
  margin: 0 13px;
  color: #D4D4D4;
}
</style>



// WEBPACK FOOTER //
// src/components/routerNavigation.vue